<script setup lang="ts">
import type { Query } from '@directus/types'

definePageMeta({
  title: 'Certifications & Policies',
  description: 'ICS certifications of quality assurance and other legal documentation.',
  order: 0,
})

const config = useRuntimeConfig()

const query: Query = {
  filter: {
    status: { _eq: 'published' },
    resource_type: { _eq: 'Certifications' },
  },
}

const { data: certifications } = await useFetch<DefaultResource[]>(
  '/api/items/resources',
  {
    key: 'page:certifications:certification-resources',
    query,
    getCachedData: (key, nuxtApp) => nuxtApp.payload.data[key],
  },
)
</script>

<template>
  <BlockContent element="section">
    <h1 class="subpage-title mb-6">
      Certificates & Policy Documents
    </h1>
    <p class="text-lg mb-12">
      Find our quality assurance, certifications, and other legal documentation here.
    </p>
    <div class="flex flex-wrap gap-y-12 f-gap-x-48-64">
      <div
        v-for="document in certifications"
        :key="document.id"
        class="space-y-6 md:max-w-2/5"
      >
        <h2 class="text-lg heading">
          {{ document.name }}
        </h2>
        <PdfThumb
          :pdf="document.pdf"
          :alt="`Preview of the document: ${document.name}`"
          placeholder-class="elevation-3"
          thumb-class="elevation-3"
        />
        <AButton
          label="Download"
          color="blue"
          icon="i-carbon-download"
          :href="`${config.public.directusUrl}/assets/${document.pdf}?download`"
        />
        <div
          class="my-8 prose"
          v-html="document.description"
        />
      </div>
    </div>
  </BlockContent>
</template>
